import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';

import styles from './HoverOverlay.styles';
import Favourite from 'components/svg/Favourite';
import PlayControl from 'components/PlayControl';
import { NavLink } from 'react-router-dom';
import * as analytics from 'analytics';
import ChevronIcon from 'components/svg/Chevron';
import { IHoverOverlay } from './HoverOverlay.interface';
import CollectionContext from 'components/Collection/CollectionContext';

const useStyles = createUseStyles(styles, { name: 'HoverOverlay' });

const HoverOverlay = (props: IHoverOverlay): JSX.Element => {
  const {
    onFavoriteToggle,
    station,
    isFavorite,
    onPlayToggle,
    isPlaying,
    saveRecentSearch,
    isLoading,
    playButtonSize,
  } = props;
  const classes = useStyles();
  const { isInSearch = false } = useContext(CollectionContext);

  const playControlProps = {
    playToggle: onPlayToggle,
    isPlaying: isPlaying && !isLoading,
    isLoading: isPlaying && isLoading,
    contentTypeId: station.contentTypeId, //used as a id to store the station in recently searched list if isInSearch is true
    slug: station.slug,
    size: playButtonSize,
    saveRecentSearch,
  };

  const navLink = {
    pathname: `${station.linkedPage}`,
    state: {
      analytics: analytics.generateTileClick(station.name, station.linkedPage, 'station page', isInSearch),
    },
  };

  const clickHandler = () => {
    onPlayToggle();
    if (isInSearch) saveRecentSearch(station.contentTypeId, station.slug);
  };

  return (
    <div data-testid="hover-overlay" className={classes.hoverOverlay}>
      <span className={classes.hoverBackdrop} onClick={clickHandler} />
      <button
        data-testid="hover-overlay-favorite-toggle"
        className={classes.favoriteButton}
        type="button"
        title={
          isFavorite ? `${station.title} verwijderen uit je collectie` : `${station.title} toevoegen aan je collectie`
        }
        onClick={onFavoriteToggle}
      >
        <Favourite isActive={isFavorite} />
      </button>
      <PlayControl {...playControlProps} />
      {station.hasPage && (
        <NavLink
          onClick={isInSearch ? () => saveRecentSearch(station.contentTypeId, station.slug) : undefined}
          className={classes.pageLink}
          data-testid="station_more_alt"
          to={navLink}
          aria-label={`Alles van ${station.title}`}
        >
          <div className={classes.title}>{`Alles van  ${station.title} `}</div>
          <div className={classes.iconWrapper}>
            <ChevronIcon className={classes.chevron} />
          </div>
        </NavLink>
      )}
    </div>
  );
};

export default HoverOverlay;
